import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;

  .box {
    border-radius: 20px;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
  }

  .full-height {
    height: 100%;
  }

  .box-title {
    text-align: center;
    line-height: 25px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 18px;
    margin-bottom: -40px;
    padding-top: 10px;
  }

  .box-content {
    display: flex;
    flex-direction: column;
    gap: 50px;
    height: 100%;
    padding-top: 10px;
    justify-content: center;
  }

  .title {
    text-align: center;
    line-height: 25px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 18px;
    padding: 0 80px;
  }

  .sub-title {
    text-align: center;
    line-height: 25px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    font-size: 18px;
  }

  .title-progresschart {
    text-align: center;
    line-height: 25px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 18px;
    padding: 10px 0 55px;
  }

  .box-progresschart {
    .title {
      text-align: center;
      line-height: 25px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
      font-size: 18px;
      padding: 10px 0;
    }

    .sub-title {
      text-align: center;
      line-height: 25px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
      font-size: 16px;
      padding: 10px 0;
    }
  }

  .box-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .title {
      text-align: center;
      line-height: 25px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
      font-size: 18px;
      padding: 10px 80px 70px;
    }
    .sub-title {
      text-align: center;
      line-height: 25px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
      font-size: 18px;
    }
  }

  .box-title__area {
    text-align: center;
    line-height: 25px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 18px;
    padding-top: 10px;
  }

  .title-table {
    text-align: center;
    line-height: 25px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 18px;
    padding-top: 20px;
  }

  .box-container {
    .ant-table-wrapper .ant-table-header .ant-table-thead > tr > th {
      font-size: 14px;
      border-right: 1px solid #00000050;
      :nth-child(1) {
        border-left: 1px solid #00000050;
      }
    }
    .ant-table-wrapper .ant-table-body .ant-table-tbody > tr {
      &.row-style-1 {
        background-color: #00000009;
      }
      :nth-last-child(1) {
        td {
          border-bottom: 1px solid #00000050;
        }
        &.ant-table-placeholder {
          td {
            border: none;
          }
        }
      }
      td {
        font-size: 13px;
        :nth-child(11) {
          white-space: nowrap;
        }
        border-right: 1px solid #00000030;
        :nth-child(1) {
          border-left: 1px solid #00000030;
        }
      }
    }
  }
`;
